import { render } from "./VolcanoPlot.vue?vue&type=template&id=027de8b2&scoped=true"
import script from "./VolcanoPlot.vue?vue&type=script&lang=js"
export * from "./VolcanoPlot.vue?vue&type=script&lang=js"

import "./VolcanoPlot.vue?vue&type=style&index=0&id=027de8b2&scoped=true&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027de8b2"]])

export default __exports__